<template>
  <div class="bundle-modal-wrapper">
    <button class="open-modal" @click="openModal">
      <span>{{ modalHeading }}</span>
      <svg class="icon"><use href="#circle-info" /></svg>
    </button>

    <modal
      v-if="modalOpen"
      :disabled="false"
      :modal-heading="modalHeading"
      :modal-open="modalOpen"
      :toggle-modal="toggleModal"
    >
      <div v-html="content" />
    </modal>
  </div>
</template>

<script>
import Modal from 'Components/Modal.vue';

export default {
  components: {
    Modal,
  },

  data() {
    return {
      content: this.$mountEl.dataset.htmlContent,
      modalHeading: this.$mountEl.dataset.modalHeading,
      modalOpen: false,
    };
  },

  methods: {
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },

    openModal() {
      this.modalOpen = true;
    },
  },
};
</script>
